// PostHog feature flag keys. Values must match the flag keys in PostHog.
// Usage: isPostHogFlagEnabled(POSTHOG_FLAGS.INTEGRATED_PYLON_WIDGET)
export const POSTHOG_FLAGS = {
  INTEGRATED_PYLON_WIDGET: 'integrated-pylon-widget',
  UNIFIED_ENGAGE_WORKSPACE: 'unified-engage-workspace',
  SHOW_OPPORTUNITY_STATUS_DROPDOWN: 'show-opportunity-status-dropdown',
  TELEHEALTH_DIAGNOSTICS: 'telehealth-diagnostics',
};
